export class CalcularFondoModel {
  edadActual = 0;
  edadRetiro = 0;
  salarioActual = 0;
  aporteVoluntario = 0;
  montoCCI = 0;
  sexo = "";
  aporteExtraodinario = 0;
}
